import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarComponent } from './calendar.component';
/**
 * NgModule definition for the Calendar component.
 */
export class CalendarModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        CalendarComponent
    ],
    exports: [
        CalendarComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CalendarModule_tsickle_Closure_declarations() {
/** @type {?} */
CalendarModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CalendarModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
